import React from "react";
import Chart from '../../../../components/ReusableComponents/ApexChartLazy';

const DonutChart = ({ data }) => {
  const options = {
    series: data || [1, 2, 3, 4],
    chart: {
      type: "donut",
    },
    labels: ["Public Transport", "Private Transport", "Walking", "Others"],
    colors: ["#4B9CD3", "#50C878", "#feb019", "#ff4e68"],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            total: {
              show: false, // Hide the total label
            },
          },
        },
      },
    },
    states: {
      hover: {
        filter: "none",
      },
    },
    legend: {
      show: true,
      onItemHover: {
        highlightDataSeries: false,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  const chartStyle = {
    maxWidth: "500px", // Set the maximum width
    maxHeight: "500px", // Set the maximum height
    margin: "auto",
  };

  return (
    <div id="chart" style={chartStyle}>
      <Chart options={options} series={options.series} type="donut" />
    </div>
  );
};

export default DonutChart;
